import './output.css';
import './styles.css';
import React from 'react';
import { Provider } from 'react-redux'
import store from './state/store'
import { StateContext } from './state/context';
import ReactDOM from 'react-dom/client';


import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <StateContext>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </StateContext>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
